const actions = {
  setPages({ commit }) {
    if (this.state.pages.form.search == null || this.state.pages.form.search == '') {
      commit('setPages', this.state.pagesContent);
    }
  },
  searchProduct({ commit }) {
    commit('setStatus', 'Buscando');
    commit('setPages', this.state.pagesContent);
    commit('searchProduct', this.state.pages.form.search);
  },
};

export default actions;
